import { useState } from 'react';
import AppHeader from '../components/AppHeader';
import CollabMeta from '../components/CollabMeta';
import Lightbox from '../components/Lightbox';
import NoteCard from '../components/NoteCard';
import NotesTabs from '../components/NotesTabs';
import { useAuth } from '../lib/auth';
import { useCollabNotes } from '../lib/collab';
import { filterIdeas } from '../lib/useIdeas';

/** `/collab` — every collaborative note you own or have joined, newest edit first. */
export default function CollabNotes() {
  const { user } = useAuth();
  const { notes, error, loading } = useCollabNotes(user?.uid);
  const [search, setSearch] = useState('');
  const [viewing, setViewing] = useState<{ images: string[]; start: number } | null>(null);

  const shown = filterIdeas(notes, search);

  return (
    <>
      <AppHeader>
        <input
          className="search"
          type="search"
          placeholder="Search collaborative notes"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </AppHeader>

      <main>
        <NotesTabs />
        {loading && <p className="muted">Loading…</p>}
        {error && <p className="error">{error}</p>}

        {!loading && !error && shown.length === 0 && (
          <p className="muted">
            {notes.length === 0
              ? 'No collaborative notes yet. Notes you share, or are invited to, appear here.'
              : `Nothing matches “${search}”.`}
          </p>
        )}

        <ul className="ideas">
          {user &&
            shown.map((note) => (
              <NoteCard
                key={note.id}
                to={`/collab/${note.id}`}
                title={note.title}
                description={note.description}
                images={note.images}
                tags={note.tags}
                // Edited, not created: a shared note's recency is its last change by anyone.
                date={note.updatedAt}
                links={note.links}
                extra={<CollabMeta note={note} uid={user.uid} />}
                onViewImage={(images, start) => setViewing({ images, start })}
              />
            ))}
        </ul>
      </main>

      {viewing && (
        <Lightbox images={viewing.images} start={viewing.start} onClose={() => setViewing(null)} />
      )}
    </>
  );
}
